import script from "./TeaserArea.vue?vue&type=script&setup=true&lang=js"
export * from "./TeaserArea.vue?vue&type=script&setup=true&lang=js"

import "./TeaserArea.vue?vue&type=style&index=0&id=0035a161&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0035a161"]])

export default __exports__